module.exports = new __parcel__URL__("sw_hoodie_icon.ee12983f.png").toString();